/* ============================================
   HOUT EXCLUSIEF - Filter Drawer JS
   Focal 13.0.0
   ============================================ */

(function () {
  'use strict';

  const CROSS_COLLECTION_URL = '/collections/all';
  const SECTION_ID = 'template--26768300802429__main';

  const state = {
    activeFilters: {},
    activeLabels: {},
    currentCollection: null,
    isLoading: false,
    stepFilters: {},
    priceSteps: []
  };

  function debounce(fn, delay) {
    let timer;
    return function () {
      const args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(null, args); }, delay);
    };
  }

  function init() {
    const drawer = document.getElementById('filter-drawer');
    if (!drawer) return;
    state.currentCollection = drawer.dataset.collection || null;
    readInitialRangeBounds();
    bindEvents();
    syncFromURL();
    updateApplyButton();
  }

  function readInitialRangeBounds() {
    const priceSection = document.querySelector('[data-price-filter]');
    if (priceSection) {
      try { state.priceSteps = JSON.parse(priceSection.dataset.priceSteps || '[]'); } catch (e) { state.priceSteps = []; }
      initPriceSlider(state.priceSteps);
    }

    document.querySelectorAll('[data-range-steps]').forEach(function (section) {
      const name = section.dataset.rangeFilter;
      let steps = [];
      try { steps = JSON.parse(section.dataset.rangeSteps || '[]'); } catch (e) {}
      state.stepFilters[name] = steps;
      initStepSlider(name, steps);
    });
  }

  function initPriceSlider(steps) {
    const lowInput  = document.getElementById('filter-range-price-low');
    const highInput = document.getElementById('filter-range-price-high');
    if (!lowInput || !highInput || !steps.length) return;
    const lastIndex = steps.length - 1;
    lowInput.min  = 0; lowInput.max  = lastIndex; lowInput.step = 1; lowInput.value = 0;
    highInput.min = 0; highInput.max = lastIndex; highInput.step = 1; highInput.value = lastIndex;
    updatePriceUI();

    const debouncedApply = debounce(updateApplyButton, 400);

    lowInput.addEventListener('input',  function () { clampRange(lowInput, highInput); updatePriceUI(); debouncedApply(); });
    highInput.addEventListener('input', function () { clampRange(lowInput, highInput); updatePriceUI(); debouncedApply(); });
    lowInput.addEventListener('change', updateApplyButton);
    highInput.addEventListener('change', updateApplyButton);
  }

  function initStepSlider(name, steps) {
    const lowInput  = document.getElementById('filter-range-' + name + '-low');
    const highInput = document.getElementById('filter-range-' + name + '-high');
    if (!lowInput || !highInput || !steps.length) return;
    const lastIndex = steps.length - 1;
    lowInput.min  = 0; lowInput.max  = lastIndex; lowInput.step = 1; lowInput.value = 0;
    highInput.min = 0; highInput.max = lastIndex; highInput.step = 1; highInput.value = lastIndex;
    updateStepUI(name);

    const debouncedApply = debounce(updateApplyButton, 400);

    lowInput.addEventListener('input',  function () { clampRange(lowInput, highInput); updateStepUI(name); debouncedApply(); });
    highInput.addEventListener('input', function () { clampRange(lowInput, highInput); updateStepUI(name); debouncedApply(); });
    lowInput.addEventListener('change', updateApplyButton);
    highInput.addEventListener('change', updateApplyButton);
  }

  function clampRange(low, high) {
    if (parseFloat(low.value) > parseFloat(high.value)) low.value = high.value;
  }

  function updatePriceUI() {
    const low    = document.getElementById('filter-range-price-low');
    const high   = document.getElementById('filter-range-price-high');
    const fill   = document.getElementById('filter-range-price-fill');
    const tLow   = document.getElementById('filter-range-price-thumb-low');
    const tHigh  = document.getElementById('filter-range-price-thumb-high');
    const minOut = document.getElementById('filter-price-min-display');
    const maxOut = document.getElementById('filter-price-max-display');
    const steps  = state.priceSteps;
    if (!low || !high || !steps.length) return;
    const lastIndex = steps.length - 1;
    const iLow  = parseInt(low.value, 10);
    const iHigh = parseInt(high.value, 10);
    const pLow  = lastIndex === 0 ? 0 : (iLow  / lastIndex) * 100;
    const pHigh = lastIndex === 0 ? 100 : (iHigh / lastIndex) * 100;
    if (fill)  { fill.style.left = pLow + '%'; fill.style.right = (100 - pHigh) + '%'; }
    if (tLow)  { tLow.style.left  = pLow + '%'; }
    if (tHigh) { tHigh.style.left = pHigh + '%'; }
    if (minOut) minOut.value = '€ ' + Math.round(steps[iLow]).toLocaleString('nl-NL');
    if (maxOut) maxOut.value = '€ ' + Math.round(steps[iHigh]).toLocaleString('nl-NL');
  }

  function updateStepUI(name) {
    const low    = document.getElementById('filter-range-' + name + '-low');
    const high   = document.getElementById('filter-range-' + name + '-high');
    const fill   = document.getElementById('filter-range-' + name + '-fill');
    const tLow   = document.getElementById('filter-range-' + name + '-thumb-low');
    const tHigh  = document.getElementById('filter-range-' + name + '-thumb-high');
    const minOut = document.getElementById('filter-' + name + '-min-display');
    const maxOut = document.getElementById('filter-' + name + '-max-display');
    const steps  = state.stepFilters[name] || [];
    if (!low || !high || !steps.length) return;
    const lastIndex = steps.length - 1;
    const iLow  = parseInt(low.value, 10);
    const iHigh = parseInt(high.value, 10);
    const pLow  = lastIndex === 0 ? 0 : (iLow  / lastIndex) * 100;
    const pHigh = lastIndex === 0 ? 100 : (iHigh / lastIndex) * 100;
    if (fill)  { fill.style.left = pLow + '%'; fill.style.right = (100 - pHigh) + '%'; }
    if (tLow)  { tLow.style.left  = pLow + '%'; }
    if (tHigh) { tHigh.style.left = pHigh + '%'; }
    if (minOut) minOut.value = steps[iLow]  ? steps[iLow].label  : '';
    if (maxOut) maxOut.value = steps[iHigh] ? steps[iHigh].label : '';
  }

  function bindEvents() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-open]'))      { openDrawer(); return; }
      if (e.target.closest('[data-filter-close]'))     { closeDrawer(); return; }
      if (e.target.closest('.filter-drawer-overlay'))  { applyFilters(); return; }
      if (e.target.closest('.filter-drawer__chip'))    { toggleChip(e.target.closest('.filter-drawer__chip')); return; }
      if (e.target.closest('.filter-drawer__swatch'))  { toggleSwatch(e.target.closest('.filter-drawer__swatch')); return; }
      if (e.target.closest('[data-filter-apply]'))     { applyFilters(); return; }
      if (e.target.closest('[data-filter-clear]'))     { clearAll(); return; }
      if (e.target.closest('[data-filter-show-more]')) { toggleShowMore(e.target.closest('[data-filter-show-more]')); return; }
      if (e.target.closest('[data-filter-remove]'))    { removeActiveFilter(e.target.closest('[data-filter-remove]')); return; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  function toggleChip(chip) {
    if (chip.classList.contains('is-disabled')) return;
    const group = chip.dataset.group;
    const value = chip.dataset.value;
    const label = chip.textContent.trim();
    if (!state.activeFilters[group]) state.activeFilters[group] = [];
    if (!state.activeLabels[group])  state.activeLabels[group]  = {};
    const idx = state.activeFilters[group].indexOf(value);
    if (idx === -1) {
      state.activeFilters[group].push(value);
      state.activeLabels[group][value] = label;
      chip.classList.add('is-active');
    } else {
      state.activeFilters[group].splice(idx, 1);
      delete state.activeLabels[group][value];
      chip.classList.remove('is-active');
    }
    updateApplyButton();
    renderActivePills();
  }

  function toggleSwatch(swatch) {
    if (swatch.classList.contains('is-disabled')) return;
    const group = swatch.dataset.group;
    const value = swatch.dataset.value;
    const label = swatch.getAttribute('aria-label');
    if (!state.activeFilters[group]) state.activeFilters[group] = [];
    if (!state.activeLabels[group])  state.activeLabels[group]  = {};
    const idx = state.activeFilters[group].indexOf(value);
    if (idx === -1) {
      state.activeFilters[group].push(value);
      state.activeLabels[group][value] = label;
      swatch.classList.add('is-active');
    } else {
      state.activeFilters[group].splice(idx, 1);
      delete state.activeLabels[group][value];
      swatch.classList.remove('is-active');
    }
    updateApplyButton();
    renderActivePills();
  }

  function toggleShowMore(btn) {
    const targetId = btn.dataset.filterShowMore;
    const hidden   = document.querySelectorAll('[data-show-more-group="' + targetId + '"]');
    const expanded = btn.dataset.expanded === 'true';
    hidden.forEach(function (el) { el.style.display = expanded ? 'none' : 'inline-block'; });
    btn.dataset.expanded = expanded ? 'false' : 'true';
    btn.textContent      = expanded ? 'Toon meer' : 'Toon minder';
  }

  function openDrawer() {
    document.getElementById('filter-drawer').classList.add('is-open');
    document.getElementById('filter-drawer-overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    document.getElementById('filter-drawer').classList.remove('is-open');
    document.getElementById('filter-drawer-overlay').classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function appendStepParams(params, name, key) {
    const steps = state.stepFilters[name] || [];
    const low   = document.getElementById('filter-range-' + name + '-low');
    const high  = document.getElementById('filter-range-' + name + '-high');
    if (!low || !high || !steps.length) return;
    const iLow  = parseInt(low.value, 10);
    const iHigh = parseInt(high.value, 10);
    if (iLow === 0 && iHigh === steps.length - 1) return;
    for (let i = iLow; i <= iHigh; i++) {
      if (steps[i]) params.append(key, steps[i].value);
    }
  }

  function appendPriceParams(params) {
    const steps = state.priceSteps;
    const low   = document.getElementById('filter-range-price-low');
    const high  = document.getElementById('filter-range-price-high');
    if (!low || !high || !steps.length) return;
    const iLow  = parseInt(low.value, 10);
    const iHigh = parseInt(high.value, 10);
    const lastIndex = steps.length - 1;
    if (iLow === 0 && iHigh === lastIndex) return;
    params.set('filter.v.price.gte', steps[iLow]);
    params.set('filter.v.price.lte', steps[iHigh]);
  }

  function buildURL() {
    const params = new URLSearchParams();

    const selectedCategories = state.activeFilters['categorie'] || [];
    let baseURL;
    if (selectedCategories.length === 0) {
      baseURL = '/collections/' + (state.currentCollection || 'all');
    } else if (selectedCategories.length === 1) {
      baseURL = '/collections/' + selectedCategories[0];
    } else {
      baseURL = CROSS_COLLECTION_URL;
    }

    const metafieldFilters = {
      houtsoort: 'filter.p.m.custom.houtsoort',
      kleur:     'filter.p.m.custom.kleur',
      bewerking: 'filter.p.m.custom.bewerking'
    };
    Object.entries(metafieldFilters).forEach(function ([group, key]) {
      (state.activeFilters[group] || []).forEach(function (val) { params.append(key, val); });
    });

    appendStepParams(params, 'dikte',   'filter.v.option.dikte');
    appendStepParams(params, 'breedte', 'filter.v.option.breedte');
    appendStepParams(params, 'lengte',  'filter.v.option.lengte');
    appendPriceParams(params);

    const qs = params.toString();
    return baseURL + (qs ? '?' + qs : '');
  }

  function applyFilters() {
    closeDrawer();
    fetchFilteredProducts(buildURL());
  }

  function fetchFilteredProducts(url) {
    if (state.isLoading) return;
    state.isLoading = true;
    const grid = document.getElementById('collection-products');
    if (grid) grid.style.opacity = '0.5';
    window.history.pushState({}, '', url);
    fetch(url + (url.includes('?') ? '&' : '?') + 'sections=' + SECTION_ID)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const sectionData = data[SECTION_ID];
        if (sectionData) {
          const parser      = new DOMParser();
          const doc         = parser.parseFromString(sectionData, 'text/html');
          const newGrid     = doc.getElementById('collection-products');
          const currentGrid = document.getElementById('collection-products');
          if (newGrid && currentGrid) {
            currentGrid.outerHTML = newGrid.outerHTML;
            const updated = document.getElementById('collection-products');
            if (updated) updated.style.opacity = '1';
          }
          updateProductCount(doc);
          updateFilterAvailability(doc);
        } else {
          window.location.href = url;
        }
      })
      .catch(function (err) {
        console.error('Filter error:', err);
        window.location.href = url;
      })
      .finally(function () {
        state.isLoading = false;
        const g = document.getElementById('collection-products');
        if (g) g.style.opacity = '1';
      });
  }

  function prefetchCount(url) {
    fetch(url + (url.includes('?') ? '&' : '?') + 'sections=' + SECTION_ID)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const sectionData = data[SECTION_ID];
        if (sectionData) {
          const parser = new DOMParser();
          const doc    = parser.parseFromString(sectionData, 'text/html');
          updateProductCount(doc);
          updateFilterAvailability(doc);
        }
      })
      .catch(function () {});
  }

  function updateProductCount(doc) {
    const countEl  = doc ? doc.querySelector('[data-product-count]') : document.querySelector('[data-product-count]');
    const count    = countEl ? countEl.dataset.productCount : '0';
    const applyBtn = document.getElementById('filter-apply-btn') || document.querySelector('[data-filter-apply]');
    if (applyBtn) {
      const n = parseInt(count);
      applyBtn.textContent = n === 0 ? 'Geen producten gevonden' : 'Toon ' + count + ' product' + (n !== 1 ? 'en' : '');
      applyBtn.disabled       = n === 0;
      applyBtn.style.opacity  = n === 0 ? '0.5' : '1';
      applyBtn.style.cursor   = n === 0 ? 'default' : 'pointer';
    }
    const toolbarCountEl = document.querySelector('[data-product-count]');
    if (toolbarCountEl) {
      const n = parseInt(count);
      toolbarCountEl.dataset.productCount = count;
      toolbarCountEl.textContent = n + ' product' + (n !== 1 ? 'en' : '');
    }
    const toolbarCount = document.querySelector('.filter-drawer__trigger-count');
    const totalActive  = countActiveFilters();
    if (toolbarCount) {
      toolbarCount.textContent   = totalActive;
      toolbarCount.style.display = totalActive > 0 ? 'inline-flex' : 'none';
    }
  }

  function updateFilterAvailability(doc) {
    if (!doc) return;
    const counts = {};
    doc.querySelectorAll('[data-group][data-value][data-count]').forEach(function (el) {
      const key = el.dataset.group + '|' + el.dataset.value;
      counts[key] = parseInt(el.dataset.count, 10) || 0;
    });

    document.querySelectorAll('.filter-drawer__chip[data-group][data-value], .filter-drawer__swatch[data-group][data-value]').forEach(function (el) {
      const key = el.dataset.group + '|' + el.dataset.value;
      if (!counts.hasOwnProperty(key)) return;
      const count = counts[key];
      const isActive = el.classList.contains('is-active');
      if (count === 0 && !isActive) {
        el.classList.add('is-disabled');
        el.setAttribute('aria-disabled', 'true');
      } else {
        el.classList.remove('is-disabled');
        el.removeAttribute('aria-disabled');
      }
    });
  }

  function countActiveFilters() {
    return Object.values(state.activeFilters).reduce(function (sum, arr) { return sum + arr.length; }, 0);
  }

  function renderActivePills() {
    const container = document.getElementById('filter-active-pills');
    if (!container) return;
    container.innerHTML = '';
    Object.entries(state.activeFilters).forEach(function ([group, values]) {
      values.forEach(function (value) {
        const label = (state.activeLabels[group] && state.activeLabels[group][value]) || value;
        const pill  = document.createElement('span');
        pill.className = 'filter-drawer__active-pill';
        pill.innerHTML = label + ' <button data-filter-remove data-group="' + group + '" data-value="' + value + '" aria-label="Verwijder filter ' + label + '">&times;</button>';
        container.appendChild(pill);
      });
    });
  }

  function removeActiveFilter(btn) {
    const group = btn.dataset.group;
    const value = btn.dataset.value;
    if (state.activeFilters[group]) state.activeFilters[group] = state.activeFilters[group].filter(function (v) { return v !== value; });
    if (state.activeLabels[group])  delete state.activeLabels[group][value];
    const chip   = document.querySelector('.filter-drawer__chip[data-group="' + group + '"][data-value="' + value + '"]');
    const swatch = document.querySelector('.filter-drawer__swatch[data-group="' + group + '"][data-value="' + value + '"]');
    if (chip)   chip.classList.remove('is-active');
    if (swatch) swatch.classList.remove('is-active');
    renderActivePills();
    applyFilters();
  }

  function clearAll() {
    state.activeFilters = {};
    state.activeLabels  = {};
    document.querySelectorAll('.filter-drawer__chip.is-active').forEach(function (el) { el.classList.remove('is-active'); });
    document.querySelectorAll('.filter-drawer__swatch.is-active').forEach(function (el) { el.classList.remove('is-active'); });

    if (state.priceSteps.length) {
      const low  = document.getElementById('filter-range-price-low');
      const high = document.getElementById('filter-range-price-high');
      if (low)  low.value  = 0;
      if (high) high.value = state.priceSteps.length - 1;
      updatePriceUI();
    }

    Object.keys(state.stepFilters).forEach(function (name) {
      const low  = document.getElementById('filter-range-' + name + '-low');
      const high = document.getElementById('filter-range-' + name + '-high');
      if (low)  low.value  = low.min;
      if (high) high.value = high.max;
      updateStepUI(name);
    });

    renderActivePills();
    applyFilters();
  }

  function syncFromURL() {
    const params = new URLSearchParams(window.location.search);
    const filterMap = {
      'filter.p.m.custom.houtsoort': 'houtsoort',
      'filter.p.m.custom.kleur':     'kleur',
      'filter.p.m.custom.bewerking': 'bewerking'
    };
    params.forEach(function (value, key) {
      const group = filterMap[key];
      if (group) {
        if (!state.activeFilters[group]) state.activeFilters[group] = [];
        if (!state.activeLabels[group])  state.activeLabels[group]  = {};
        state.activeFilters[group].push(value);
        const chip   = document.querySelector('.filter-drawer__chip[data-group="' + group + '"][data-value="' + value + '"]');
        const swatch = document.querySelector('.filter-drawer__swatch[data-group="' + group + '"][data-value="' + value + '"]');
        if (chip)   { chip.classList.add('is-active');   state.activeLabels[group][value] = chip.textContent.trim(); }
        if (swatch) { swatch.classList.add('is-active'); state.activeLabels[group][value] = swatch.getAttribute('aria-label'); }
      }
    });

    Object.keys(state.stepFilters).forEach(function (name) {
      const key   = 'filter.v.option.' + name;
      const vals  = params.getAll(key);
      const steps = state.stepFilters[name] || [];
      if (vals.length && steps.length) {
        const indices = [];
        steps.forEach(function (step, i) { if (vals.indexOf(step.value) !== -1) indices.push(i); });
        if (indices.length) {
          const low  = document.getElementById('filter-range-' + name + '-low');
          const high = document.getElementById('filter-range-' + name + '-high');
          if (low && high) {
            low.value  = Math.min.apply(null, indices);
            high.value = Math.max.apply(null, indices);
            updateStepUI(name);
          }
        }
      }
    });

    const priceGte = params.get('filter.v.price.gte');
    const priceLte = params.get('filter.v.price.lte');
    if ((priceGte || priceLte) && state.priceSteps.length) {
      const low  = document.getElementById('filter-range-price-low');
      const high = document.getElementById('filter-range-price-high');
      if (low && high) {
        if (priceGte) {
          const idx = state.priceSteps.indexOf(Number(priceGte));
          if (idx !== -1) low.value = idx;
        }
        if (priceLte) {
          const idx = state.priceSteps.indexOf(Number(priceLte));
          if (idx !== -1) high.value = idx;
        }
        updatePriceUI();
      }
    }

    renderActivePills();
    updateApplyButton();
  }

  function updateApplyButton() {
    prefetchCount(buildURL());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();